import { Product } from '@evenfinancial/even-ts-static'
import { formattedPhoneNumber } from 'embed/utils'
import { LEGAL_GENERAL_UUID_DEV, LEGAL_GENERAL_UUID_PROD } from 'embed/constants'

interface TCPAContext {
  product: Product
  companyUuid?: string
}

export const contextFrom = (product: Product, companyUuid?: string): TCPAContext => ({
  product,
  companyUuid,
})

export const fcraLanguage = (buttonText: string, name: string): string =>
  `By clicking ${buttonText}, I hereby consent to the "E-Sign Agreement", the "Credit Authorization Agreement", the Terms of Service and Privacy Policy, and am providing written consent under the FCRA for ${name}, and its partners to obtain consumer report information from my credit profile.`

export const tcpaLanguage = (context: TCPAContext, name: string, phone: string): string => {
  switch (context.product) {
    case Product.LifeInsurance:
      switch (context.companyUuid) {
        case LEGAL_GENERAL_UUID_DEV:
        case LEGAL_GENERAL_UUID_PROD:
          return `By clicking agree and continue I hereby consent to the Terms of Service and Privacy Policy. I consent to be contacted and receive calls, emails, and text messages from ${name}, and their partners, financial professionals, third parties calling on their behalf and their affiliated companies, regarding Legal & General America products and services as well as to explore various financial products and services at the phone number(s) I provided above, including my wireless number if provided. I understand these calls may be generated using an automatic telephone dialing system or prerecorded voice message for telemarketing purposes. I understand to make a purchase I do not need to consent to receive calls and can instead contact a customer care representative by calling ${formattedPhoneNumber(
            phone,
          )}.`
        default:
          return `By clicking agree and continue I hereby consent to the Terms of Service and Privacy Policy. I agree to be contacted by ${name} and its partners and their affiliated companies via email and/or at the telephone number(s) I have provided, including contact through automatic dialing systems, artificial or pre-recorded voice messaging, or text message. Consent is not required as a condition to utilize LeapLife and you may choose to be contacted by an individual customer care representative(s) by calling ${formattedPhoneNumber(
            phone,
          )}.`
      }
    default:
      return `I agree to be contacted by ${name} and its partners and their affiliated companies via email, postal mail service and/or at the telephone number(s) I have provided above to explore various financial products and services I inquired about and/or that may be of interest to me, including contact through automatic dialing systems, artificial or pre-recorded voice messaging, or text message. Consent is not required as a condition to utilize ${name}, and you may choose to be contacted by an individual customer care representative(s) by calling ${formattedPhoneNumber(
        phone,
      )}.`
  }
}
